import { ELocalization } from '@enums/localization.enum';

import i18n from '../configs/i18n/i18n.config';

export const changeLanguage = (language: ELocalization): void => {
  i18n.changeLanguage(language);
};
